module.exports = __webpack_public_path__ + "static/media/1.36bd58f1.jpg";